<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    class="heroicon-shield-lock heroicon heroicon-sm"
  >
    <path
      class="heroicon-shield-lock-edge heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M47.05 51.47C52 49 56 42.52 56 37V5.91C47.89 2.01 39-.01 30 0 21-.01 12.11 2 4 5.91v31.1c0 5.5 4 12 8.95 14.46L30 60l17.05-8.53z"
    ></path>
    <path
      class="heroicon-shield-lock-background heroicon-component-fill"
      fill="#FFFFFF"
      d="M30 10c-5.49 0-10.87.88-16 2.61v24.4c0 1.72 1.87 4.74 3.42 5.52L30 48.82l12.58-6.29C44.13 41.75 46 38.73 46 37V12.61A49.94 49.94 0 0 0 30 10z"
    ></path>
    <path
      class="heroicon-shield-lock-circle heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M18 28a12 12 0 1 0 24 0 12 12 0 0 0-24 0z"
    ></path>
    <path
      class="heroicon-shield-lock-symbol heroicon-component-fill"
      fill="#FFFFFF"
      d="M25 26v-1a5 5 0 0 1 10 0v1h2v8H23v-8h2zm6 0v-1a1 1 0 0 0-2 0v1h2z"
    ></path>
    <path
      class="heroicon-shadows"
      fill="#000000"
      d="M47 12v-.1A50.9 50.9 0 0 0 30 9a50.8 50.8 0 0 0-17 2.9v.1L9 9.14A54.82 54.82 0 0 1 30 5a54.8 54.8 0 0 1 21 4.15L47 12zm-1 .61v2A49.95 49.95 0 0 0 30 12a49.8 49.8 0 0 0-16 2.6v-2A49.94 49.94 0 0 1 30 10c5.49 0 10.87.88 16 2.61z"
      opacity=".2"
    ></path>
    <path
      class="heroicon-outline"
      fill="#4A4A4A"
      fill-rule="nonzero"
      d="M56 37c0 5.51-4 12-8.95 14.46L30 60l-17.05-8.53C8 49 4 42.51 4 37V5.91C12.11 2.01 21-.01 30 0c9.31 0 18.13 2.12 26 5.91v31.1V37zM30 2C21.6 2 13.47 3.78 6 7.18V37c0 4.76 3.58 10.55 7.84 12.69L30 57.76l16.16-8.07C50.42 47.55 54 41.77 54 37V7.18A57.78 57.78 0 0 0 30 2zM9 37V9.14A54.82 54.82 0 0 1 30 5a54.8 54.8 0 0 1 21 4.15V37c0 3.63-2.94 8.38-6.18 10L30 54.41l-14.82-7.4C11.94 45.37 9 40.62 9 37zm35.37 9.1C47.27 44.65 50 40.25 50 37V9.81A53.84 53.84 0 0 0 30 6c-6.9 0-13.66 1.3-20 3.82V37c0 3.25 2.73 7.65 5.63 9.1L30 53.3l14.37-7.2zM30 51.06l-13.47-6.74C14.3 43.2 12 39.49 12 37V11.2A51.76 51.76 0 0 1 30 8c6.14 0 12.24 1.08 18 3.2V37c0 2.49-2.29 6.2-4.53 7.32L30 51.06zM14 12.6V37c0 1.73 1.87 4.75 3.42 5.53L30 48.82l12.58-6.29c1.55-.78 3.42-3.79 3.42-5.52v-24.4A49.95 49.95 0 0 0 30 10a49.94 49.94 0 0 0-16 2.6zM30 40a12 12 0 1 1 0-24 12 12 0 0 1 0 24zm10-12a10 10 0 1 0-20 0 10 10 0 0 0 20 0zm-15-2v-1a5 5 0 0 1 10 0v1h2v8H23v-8h2zm6 0v-1a1 1 0 0 0-2 0v1h2zm1 0h2v-1a4 4 0 1 0-8 0v1h2v-1a2 2 0 1 1 4 0v1zm-8 7h12v-6H24v6z"
    ></path>
  </svg>
</template>
